export class Address {
    addressLine1: string;
    addressLine2: string;
    district: string;
    state: string;
    city: string;
    zipcode: string;
    country: string;
    geocode: string;
}